export default __webpack_public_path__ + "static/media/PersonalizedTeledentistry.d51ac3ac.png";